<template>
  <div id="app">
    <div v-if="$route.path !== '/message'" class="container title-bar">
      <nav class='navbar navbar-expand-xl logoup-navbar'>
        <a  class="navbar-brand" href="#">
          <img src='/static/logoup-512.png' style='width: 3.2rem'>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false"><title>Menu</title><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path></svg>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item active">
              <router-link class="nav-link" to='/home'><span style="white-space:nowrap">LogoUp 3D</span> <span style="white-space:nowrap">三维创新设计平台</span></router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to='/competition'>青少年创意设计大赛</router-link>
            </li>
             <!-- <li class="nav-item">
              <router-link class="nav-link" to='/message'>2026年3D大赛</router-link>
            </li>
           <li class="nav-item">
              <router-link class="nav-link" to='/entryForm'>预选赛作品</router-link>
            </li> -->
            <!-- <li class="nav-item">
              <router-link class="nav-link" to='/queryForm'>预选赛查询/修改</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to='/entryFormFinal'>决赛作品提交</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to='/queryFormFinal'>决赛查询/修改</router-link>
            </li> -->
            <li class="nav-item">
              <router-link class="nav-link" to='/course'>课程资源</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://hesion3d.com/#/">3D打印机</a>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to='/about'>关于我们</router-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <router-view></router-view>
    <div v-if="$route.path !== '/message'" class="foot-bar">
      <div class="container">
        <div class="row">
          <div class="foot-section col-lg-2 col-sm-4 col-6">
            <h3>客户服务</h3>
            <a class="foot-link" href="http://hesion3d.com/#/buy">购买指南</a>
            <a class="foot-link" href="http://hesion3d.com/#/retailer">渠道与大客户服务</a>
            <a class="foot-link" href="http://m.kuaidi100.com" target="_blank">快递查询</a>
          </div>
          <div class="foot-section col-lg-2 col-sm-4 col-6">
            <h3>法律说明</h3>
            <a class="foot-link" href="http://hesion3d.com/#/policy">法律声明</a>
            <a class="foot-link" href="http://hesion3d.com/#/privacy">隐私条款</a>
            <a class="foot-link" href="http://hesion3d.com/#/property">知识产权声明</a>
          </div>
          <div class="foot-section col-lg-2 col-sm-4 col-6">
            <h3>关于公司</h3>
            <router-link class="foot-link" to="/about">公司简介</router-link>
            <a class="foot-link" href="http://hesion3d.com/#/team">合伙人与团队</a>
            <router-link class="foot-link" to="/gymnasium">3D技术科普体验馆</router-link>
            <a class="foot-link" href="http://hesion3d.com/#/job">加入我们</a>
          
          </div>
          <div class="foot-section col-lg-2 col-sm-4 col-6">
            <h3>媒体中心</h3>
            <a class="foot-link" href="http://hesion3d.com/#/works">作品展示</a>
            <a class="foot-link" href="http://hesion3d.com/#/media">媒体资源</a>
            <a class="foot-link" href="http://hesion3d.com/#/investment">投资人关系</a>
          </div>
          <div class="foot-section ml-lg-auto col-lg-3  col-md-5 col-sm-6 col-12">
            <a href="#/contact"><h3>联系我们</h3></a>
            <div class="phone">010-6296-6651</div>
            <div class="exp"><span style="white-space:nowrap">周一至周五 9:00-18:00</span> <span style="white-space:nowrap">（仅收普通话费）</span></div>
            <div class="email"><a href="mailto:service@hesion3d.com">service@hesion3d.com</a></div>
          </div>
        </div>
        <div class="copyright-bar">
          <div>版权所有 &copy; 2014-2021, 北京清软海芯科技有限公司。所有权利保留。</div>
          <div class="miibeian">
            <!-- <a href="http://www.miibeian.gov.cn/" target="_blank" style="margin-right:1em;white-space:nowrap">京 ICP 备 14057314 号</a> -->
            <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-right:1em;white-space:nowrap">京ICP备14057314号</a>
            <a href="http://www.miibeian.gov.cn/" target="_blank" style="white-space:nowrap">京公安网备 11010802017110 号</a>
          </div>
          <div style="color:#dedede;height:2px;overflow:hidden">
            海芯, 清软, 优琢, 3D, 打印, 打印机, 增材制造, 熔融沉积, 海芯科技, Neobox, 打印工场, mall3d, printing, hesion, fdm, 小飞侠, pancake, 三弟画饼。
            海芯科技是一家 3D 打印机制造商和 3D 打印服务提供商，致力于让所有公众享受到 3D 打印技术变革带来的方便和欣喜，推动 3D 打印技术和娱乐的全面对接。
            海芯科技 - 智慧商用 3D 打印技术引领者
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
    };
  },
};
</script>

<style>
@media (min-width: 1200px) {
#navbarNav .nav-link {
  padding: 2rem;
}
}
.navbar.navbar-expand-xl.logoup-navbar {
  padding-top: 0;
  padding-bottom: 0;
}
#app {
  font-family: '微软雅黑', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
}
#app a {
  text-decoration: none;
  color: #666;
}
#app a:hover {
  color: #0078d7;
}
body {
  margin: 0;
}
h3 {
  font-weight: normal;
}
.content {
  text-align: left;
  display: inline-block;
}
.title-bar .router-link-active {
  color: #fff;
  background: #3f98ee;
}
.foot-bar {
  border-top: solid 1px #ccc;
  background: #f0f0f0;
  padding-top: 1rem;
  padding-bottom: 3rem;
}
.foot-section {
  padding-top: 1rem;
}
.foot-bar h3 {
  font-size: 1.3rem;
  font-weight: 100;
  margin-bottom: 0.5rem;
}
.foot-link {
  font-size: 0.7rem;
  display: block;
  margin-top: 0.3rem;
}
.phone {
  font-size: 1.3rem;
  font-weight: 100;
}
.exp {
  font-size: 0.7rem;
  font-weight: 100;
}
.copyright-bar {
  margin-top: 1rem;
  font-size: 0.7rem;
}
.content-section .text {
  color: #666;
  font-weight: 100;
  line-height: 1.7em;
}
.content-section ol {
  list-style: disc;
}
.content-section h3 {
  font-weight: 100;
  font-size: 1.8rem;
  border-left: solid 16px #0078d7;
  padding-left: 16px;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.content-section h3 div {
  font-size: 1.4rem;
  color: #666;
}
h4 {
  font-size: 24px;
  font-weight: 100;
}
</style>



// WEBPACK FOOTER //
// src/App.vue